import { MutableRefObject, useEffect, useRef } from 'react'
import { FilterProps } from '../../utils'
import { Select } from '@msaf/core-react'

type FilterSelectOption = {
  label: string
  value: string
}
interface FilterSelectProps extends FilterProps {
  options?: FilterSelectOption[]
}

export function FilterSelect({ filterKey, value, setValue, options, onKeyDown }: FilterSelectProps) {
  if (typeof value !== 'string') throw new Error('Invalid value type for `select`')

  const inputRef: MutableRefObject<HTMLSelectElement | null> = useRef(null)

  useEffect(() => {
    inputRef.current?.focus()
  }, [inputRef])

  return (
    <Select
      ref={inputRef}
      id={`search-filter-input-label-${filterKey}`}
      onChange={(e) => setValue(e.target.value)}
      value={value}
      options={options}
      onKeyDown={onKeyDown}
      placeholderType='hidden'
    />
  )
}
